export var DEFAULT_MASK_LEVEL = 'medium';